import { SelectedRoomFilters } from 'entities/tour/models/selection-store/selection-store.ts'

export const EmptyFilters: SelectedRoomFilters = {
  meal_type: [],
  operators: [],
  room_types: [],
}
